import { Observable } from 'rxjs';
import { IGetGateway, ISaveGateway } from '../gateways';
import {
  CONFIGURATION_SCHEMA,
  DEFAULT_CONFIGURATION,
  IConfiguration,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { z } from 'zod/v4';

export class ConfigurationGateway
  implements
    IGetGateway<null, IApiResponse<IConfiguration[]> | null>,
    ISaveGateway<IConfiguration[], IApiResponse<IConfiguration[]> | null>
{
  private readonly restCallBuilder: RestCallBuilder<IConfiguration[]> =
    new RestCallBuilder<IConfiguration[]>(DEFAULT_CONFIGURATION);

  get(): Observable<IApiResponse<IConfiguration[]>> {
    return this.restCallBuilder
      .get('/configuration/')
      .validate(
        API_RESPONSE_SCHEMA(z.array(CONFIGURATION_SCHEMA)),
        'Configuration.get'
      )
      .handleMessages()
      .build();
  }

  getByLicenseKey(
    licenseKey: string
  ): Observable<IApiResponse<IConfiguration[]>> {
    return this.restCallBuilder
      .get(`/configuration/${encodeURIComponent(licenseKey)}`)
      .validate(
        API_RESPONSE_SCHEMA(z.array(CONFIGURATION_SCHEMA)),
        'Configuration.getByLicenseKey'
      )
      .handleMessages()
      .build();
  }

  save(query: IConfiguration[]): Observable<IApiResponse<IConfiguration[]>> {
    return this.restCallBuilder
      .post('/configuration/', query)
      .validate(
        API_RESPONSE_SCHEMA(z.array(CONFIGURATION_SCHEMA)),
        'Configuration.save'
      )
      .handleMessages()
      .build();
  }
}
